const plusJakarta = "'Plus Jakarta Sans', sans-serif";

const typography = {
  fontFamily: plusJakarta,
  fontWeightMedium: 500,
  h1: {
    fontWeight: 700,
    fontSize: '2.25rem',
    lineHeight: '2.75rem',
    letterSpacing: '-0.02em',
    fontFamily: plusJakarta,
  },
  h2: {
    fontWeight: 700,
    fontSize: '1.875rem',
    lineHeight: '2.25rem',
    letterSpacing: '-0.02em',
    fontFamily: plusJakarta,
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
    letterSpacing: '-0.01em',
    fontFamily: plusJakarta,
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.3125rem',
    lineHeight: '1.6rem',
    letterSpacing: '-0.01em',
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.6rem',
  },
  h6: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.4rem',
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
  },
  body1: {
    fontSize: '0.9375rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  body2: {
    fontSize: '0.8125rem',
    letterSpacing: '0rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: '0.9375rem',
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '0.8125rem',
    fontWeight: 400,
  },
};

export default typography;
